type PlaceLike = {
  city?: null | string
  country?: null | string
  country_code?: null | string
  postcode?: null | string
}

export const formatPlaceSummary = (place?: null | PlaceLike) =>
  [place?.country_code || place?.country, place?.postcode, place?.city].filter(Boolean).join(', ')
